import React from 'react';
import { Item, Root } from '@radix-ui/react-navigation-menu';
import type { CSS } from '@components-shared/src/stitches';
import { DropdownIcon } from '../media/icons/DropdownIcon';
import { DropdownContainer, ListContainer, Option, TriggerStyles } from './DropdownStyles';
import { DropdownTextHeader } from './DropdownTextHeader';

export const ObjectDropdownSelect = ({
  options,
  selection,
  setSelection,
  headerType = 'text',
  variant,
  dropdownStyles,
  rootStyles,
  triggerStyles,
  displayKey,
  valueKey,
}: {
  options: { [key: string]: string }[];
  selection: string;
  setSelection: (selection: { [key: string]: string }) => void;
  headerType?: 'text' | 'icon';
  variant?: 'end';
  dropdownStyles?: CSS;
  rootStyles?: CSS;
  triggerStyles?: CSS;
  displayKey: string;
  valueKey: string;
}) => {
  return (
    <>
      <Root>
        <ListContainer css={rootStyles}>
          <Item>
            <TriggerStyles css={triggerStyles}>
              {headerType === 'text' ? (
                <DropdownTextHeader selection={selection} />
              ) : (
                <DropdownIcon />
              )}
            </TriggerStyles>
            <DropdownContainer variant={variant} css={dropdownStyles}>
              {options.map(option => (
                <Option key={option[valueKey]} onClick={() => setSelection(option)}>
                  {option[displayKey]}
                </Option>
              ))}
            </DropdownContainer>
          </Item>
        </ListContainer>
      </Root>
    </>
  );
};

ObjectDropdownSelect.displayName = 'ObjectDropdownSelect';
